import {useQuery} from "@tanstack/react-query";
import {readRevenueByTeamByLastYear} from "../../../../../api/main/DashboardApi";

export const useReadRevenueByTeamByLastYear = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByTeamByLastYear"],
        queryFn: async () => await readRevenueByTeamByLastYear(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
